module.exports = __webpack_public_path__ + "static/fonts/DINProLight.2de9bba9.ttf";